<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Remove Invoice Line?</p>
      </header>
      <section class="modal-card-body">
        Are you sure?
      </section>
      <footer class="modal-card-foot space-between">
        <b-button @click="$parent.close()">Close</b-button>
        <b-button
          type="is-danger"
          native-type="submit"
          :disabled="!ready"
        >Remove Line</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapGetters(['api']),
    ready () {
      return (this.line !== null)
    }
  },
  methods: {
    save () {
      this.saving = true
      const endpoint = this.api.route + '/admin/client-invoice-lines/' + this.line.id
      this.$http.delete(endpoint).then(response => {
        this.$parent.close()
        this.$buefy.toast.open({ type: 'is-success', message: 'Invoice line removed!' })
        this.$emit('invoice:saved', response.data)
      }).catch(error => {
        this.errors = error.response.data.errors
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please review your input and try again.' })
      }).finally(() => {
        this.saving = false
      })
    }
  },
  props: {
    invoice: {
      type: Object,
      required: true
    },
    line: {
      type: [Object, null]
    }
  }
}
</script>
